import * as R from 'remeda';
import type { StateUpdater } from '../store';
import { constrainToViewport, getCanvasContext } from './operations';
import type { CameraSlice } from './types';

// ============================================================================
// State Transformers (exported for use by other slices)
// ============================================================================

export const setViewportRect =
  <Root extends CameraSlice>(
    viewportRect: CameraSlice['canvas']['viewportRect']
  ): StateUpdater<Root> =>
  state => {
    const ctx = getCanvasContext({ ...state.canvas, viewportRect });
    return {
      ...state,
      canvas: {
        ...state.canvas,
        viewportRect,
        transform: constrainToViewport(ctx)(state.canvas.transform),
      },
    };
  };

export const setCanvasDimensions =
  <Root extends CameraSlice>(
    dimensions: CameraSlice['canvas']['dimensions']
  ): StateUpdater<Root> =>
  state =>
    R.isDeepEqual(state.canvas.dimensions, dimensions)
      ? state
      : {
          ...state,
          canvas: {
            ...state.canvas,
            dimensions,
          },
        };
